const SRC = {
  git: `img/git.png`,
  gitHref: `https://github.com/YulikK`,
  gitAlt: `GitHub`,
  rs: `img/RS.png`,
  rsAlt: `RS School`,
  rsHref: `https://rs.school/js/`,
  isEdit: `img/is-edit.png`,
  altIsEdit: `is edit`,
  user: `img/user.png`,
  userAlt: `user`,
  logo: `img/logo.png`,
  logoAlt: `logo`,
  spinner: `img/spinner.gif`,
  spinnerAlt: `spinner`,
  p404: `img/404.png`,
  p404Alt: `404`
}

export default SRC;
